module.exports = __webpack_public_path__ + "static/media/country_my.9ddf75b7.webp";